'use strict';

const Enum = require('./enum');

/**
 * Defines entity types for activity feed
 *
 * @enum
 * @readonly
 */
const Entities = Object.create(Enum, {
  ALARM_RF_BUTTON: { value: 'alarm_rf_button', enumerable: true },
  ALARM_CONTACT_SENSOR_INDOOR: { value: 'alarm_contact_indoor', enumerable: true },
  ALARM_CONTACT_SENSOR_OUTDOOR: { value: 'alarm_contact_outdoor', enumerable: true },
  ALARM_HUB: { value: 'alarm', enumerable: true },
  ALARM_KEYFOB: { value: 'alarm_keyfob', enumerable: true },
  ALARM_KEYPAD: { value: 'alarm_keypad', enumerable: true },
  ALARM_PIR_INDOOR: { value: 'alarm_pir_indoor', enumerable: true },
  ALARM_PIR_OUTDOOR: { value: 'alarm_pir_outdoor', enumerable: true },
  ALARM_SHOCK_SENSOR: { value: 'alarm_shock_sensor', enumerable: true },
  ALARM_SIREN_INDOOR: { value: 'alarm_siren_indoor', enumerable: true },
  ALARM_SIREN_OUTDOOR: { value: 'alarm_siren_outdoor', enumerable: true },
  ALARM_SMOKE_SENSOR: { value: 'alarm_smoke_sensor', enumerable: true },
  BRIDGE: { value: 'bridge', enumerable: true },
  CAMERA: { value: 'camera', enumerable: true },
  DOORBELL: { value: 'doorbell', enumerable: true },
  HOUSE: { value: 'house', enumerable: true },
  KEYPAD: { value: 'keypad', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },
  DOOR_POSITION_SENSOR: { value: 'dps', enumerable: true },
  USER: { value: 'user', enumerable: true },

  // window actuator system(WA)
  WA_HUB: { value: 'wa_hub', enumerable: true },
  WA_REMOTE: { value: 'wa_remote', enumerable: true },
  WA_ACTUATOR: { value: 'wa_actuator', enumerable: true },
  WA_SYSTEM: { value: 'wa_system', enumerable: true },
});

exports.Entities = Entities;
